import type { AppGlueAny } from "../../../Common/AppGlueAny";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { AndGroup, GroupingType } from "./AndGroup";

export class OrGroup extends AndGroup {
    readonly __type: string = "Or Group";

    constructor() {
        super();
        this.typeOfGroup = GroupingType.OR;
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return !!this.elements.find((e) => e.evaluate(data, testContext) === true);
    }
}
